

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {Prop} from "vue-property-decorator";
  import {RawLocation} from "vue-router";
  import {ICell} from "@/model/Locker/lockerInterfaces";

  @Component({
    components: {}
  })
  export default class CellChip extends Vue {

    @Prop()
    protected cell!: ICell;

    protected get direction(): string {
      const direction = this.cell.direction;
      const label = 'lockers.cells.direction.' + direction;
      const translated = this.$t(label).toString();
      return translated == label ? direction : translated;
    }

  }

